import { useEffect } from "react";
import {
  decodeQueryParams,
  decodeQueryParamsToObject,
} from "../../../../utils/EncodeDecodeQueryParams";
import {
  createPengecekanSaved,
  getKendaraanIdFromUrl,
} from "../../utils/editorHelpers";

const useEditorInitialLoad = ({
  id,
  location,
  currentUrl,
  headerData,
  setHeaderData,
  setListProblemData,
  setPengecekanSaved,
  fetchHeader,
}) => {
  // first time initializations
  useEffect(() => {
    setListProblemData([]);
    const isNew = currentUrl.includes("new");
    if (isNew) {
      // load default header from url query "key"
      const urlParams = new URLSearchParams(location.search);
      const key = urlParams.get("key");
      if (key) {
        decodeQueryParams(key).then((decodedKey) => {
          const urlParams = new URLSearchParams(decodedKey);
          const filterNew = urlParams.get("filter");
          if (filterNew) {
            const { filterText, filterObject } = decodeQueryParamsToObject({
              filterText: filterNew,
              configFilters: [
                {
                  field: "kendaraan_id",
                  alias: "kendaraan",
                  type: "object",
                },
              ],
            });
            if (filterObject.kendaraan) {
              setHeaderData({
                ...headerData,
                data_kendaraan: filterObject.kendaraan,
                kendaraan_id: filterObject.kendaraan.id,
              });
            }
          }
        });
      }
      setPengecekanSaved(createPengecekanSaved());
    } else {
      fetchHeader(id);
    }

    // (the verif settings are not loaded here, see useEditorVerifSetting)
  }, []);
};

// the kendaraan of the url (?kendaraan_id=...)
export const useEditorKendaraanFromUrl = ({ location, fetchKendaraanById }) => {
  useEffect(() => {
    const kendaraanId = getKendaraanIdFromUrl();
    console.log(kendaraanId);
    if (kendaraanId) fetchKendaraanById({ kendaraanId });
  }, [location.href]);
};

export default useEditorInitialLoad;
